<template>
	<button
		class="hover:bg-surface-base first-of-type:rounded-t-base last-of-type:rounded-b-base flex w-full items-center gap-200 first-of-type:pt-150 last-of-type:pb-150 hover:cursor-pointer disabled:cursor-not-allowed"
		role="menuitem"
		type="button"
		:aria-disabled="props.disabled ? 'true' : undefined"
		:aria-label="computedAriaLabel"
		:class="[
			disabled ? 'text-on-surface-dim' : variant ? variant : 'text-on-surface',
			isMobile ? 'gap-200 px-400 py-200' : 'border-l-4 px-200 py-150 not-focus:border-transparent',
			variant,
		]"
		:disabled="disabled"
		:title="computedTitle"
		@click="handleClick"
	>
		<Icon
			v-if="icon"
			:type="icon"
			class="shrink-0"
		/>
		<span class="truncate">{{ label }}</span>
	</button>
</template>

<script setup lang="ts">
	// Packages
	import { computed } from 'vue';

	import Icon from '@hub-client/components/elements/Icon.vue';

	import { type ContextMenuItemProps, type ContextVariant } from '@hub-client/models/components/contextMenu.models';

	// Stores
	import { useSettings } from '@hub-client/stores/settings';

	// Props
	const props = withDefaults(defineProps<ContextMenuItemProps>(), {
		disabled: false,
		variant: '' as ContextVariant,
	});

	// Lifecycle
	const emit = defineEmits<{
		(e: 'click', evt: MouseEvent): void;
	}>();
	// Computed
	const settings = useSettings();
	const isMobile = computed(() => settings.isMobileState);

	const computedAriaLabel = computed(() => {
		if (props.label) return props.label;
		if (props.title) return props.title;
		return props.ariaLabel ?? undefined;
	});

	const computedTitle = computed(() => {
		if (props.title) return props.title;
		if (props.label) return props.label;
		return undefined;
	});

	const handleClick = (evt: MouseEvent) => {
		emit('click', evt);
	};
</script>
